import React, { useContext, useEffect } from 'react';

import Notice from './Notice';
import { NoticesContext } from './NoticesProvider';

const NoticeCollection: React.FC = () => {
  const { notice, hasLoaded, fetchNotice } = useContext(NoticesContext);

  useEffect(() => {
    if (!hasLoaded) {
      void fetchNotice();
    }
  }, [hasLoaded, fetchNotice]);

  if (!notice) return null;

  return <Notice notice={notice} fetchNextNotice={fetchNotice} />;
};

export default NoticeCollection;
